<template>
<div>
  <v-subheader
    v-if='label'
    class='overline pl-2' >
    {{label}}
    <v-spacer />
    <v-btn x-small icon
      @click='init'
      :loading="global.request.me.loading || global.request.lookups.loading" >
      <v-icon>mdi-replay</v-icon>
    </v-btn>
  </v-subheader>

  <template v-if='multiple' >
    <v-checkbox dense hide-details
      v-for='practitioner in practitioners'
      v-model='selected'
      :key="practitioner.id"
      :value='practitioner.id'
      :label='practitioner.full_name'
      class='pa-0 ma-0' />
  </template>
  <template v-else >
    <v-radio-group
      v-model='selected' >
      <v-radio dense hide-details
        v-for='practitioner in practitioners'
        :key="practitioner.id"
        :value='practitioner.id'
        :label='practitioner.full_name'
        class='pa-0 ma-0' />
    </v-radio-group>
  </template>
  <span class='caption grey--text' v-if='hint' v-text='hint' />

  <p v-if='practitioners && practitioners.length === 0' >
    We didn't find any practitioners for {{spaceName}}
  </p>
</div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'InlinePractitionerPicker',
  props: {
    value: { },
    spaceId: { required: false },
    multiple: { type: Boolean, default: true },
    label: { type: String, required: false },
    hint: { type: String, required: false }
  },
  data () {
    return {
      selected: null
    }
  },
  mounted () {
    if (this.multiple) { this.selected = [] }
    else { this.selected = null }
    if (this.value) {
      this.selected = this.value
    }
  },
  watch: {
    selected () {
      this.$emit('input', this.selected)
      this.$emit('selected', this.selected)
    },
    value () {
      if (this.value) {
        this.selected = this.value
      } else {
        if (this.multiple) { this.selected = [] }
        else { this.selected = null }
      }
    },
    practitionerId: {
      immediate: true,
      handler () {
        if (this.practitionerId) {
          if (this.multiple) { this.selected = [this.practitionerId] }
          else { this.selected = this.practitionerId }
        }
      }
    }
  },
  computed: {
    ...mapGetters('identity', [
      'me',
      'meId',
      'lookups',
      'practitionersList',
      'getPractitionerById',
      'getPractitionersInSpace'
    ]),
    practitionerId () {
      if (this.selected) {
        if (this.selected.id) {
          return this.selected.id
        }
        return this.selected
      }
      return null
    },
    practitioners () {
      if (this.spaceId) {
        return this.getPractitionersInSpace(this.spaceId)
      } else {
        return this.practitionersList
      }
    },
    practitioner () {
      let practitionerId = this.practitionerId
      if (!practitionerId) { practitionerId = this.meId }
      return this.getPractitionerById(practitionerId)
    }
  }
}
</script>
